import { BasePagePath } from 'app/core/workflow/page-path/base-page.path';

export class CouponsPagePath extends BasePagePath {
  public static path(): string {
    return 'coupons';
  }
}
